
import { MapLocation } from '@/types/location';

// House of Network Games Locations
export const houseOfNetworkGameCenters: MapLocation[] = [
  {
    id: 43001,
    name: "House of Network Games - Jeddah (Al Zahra)",
    type: "Game Center",
    devices: 5,
    coordinates: [21.582702014178956, 39.129234022088276],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "10-35",
    orientation: "Portrait",
    segment: "Game"
  }
];
